











import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
@Component({
  name: 'ButtonAsync'
})
export default class extends Vue {
    @Prop({ required: true }) private onClick!: object

    private loading: Boolean = false;
    private handleClick() {
      this.loading = true
      try {
        // @ts-ignore
        this.onClick().finally(() => {
          // console.log('结束了')
          this.loading = false
        })
      } catch (err) {
        // console.log('结束了error')
        console.warn(err)
        this.loading = false
      }
    }
}
